var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('p',{staticClass:"bottom-text"},[_vm._v(" I agree to abide by the "),_c('ASCAArtIncLink'),_vm._v(", "),_c('BylawsLink'),_vm._v(", and rules of the ASCA Registry and all other ASCA programs. ")],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }